console.log("ONS18DM - Post-Insurance Form Landing Screen Test Bucketed");
(function () {
    // Test configuration
    const TEST_CONFIG = {
        id: 'SB095DM',
        name: 'Key Ingredients vs 3rd Party Tested Anchor Links',
        variation: 1,
        selector: '.product__info-wrapper .product__text.subtitle',
        variationClass: '.SB095DM'
    };

    const helpers = {
        waitForElem: function (waitFor, callback, minElements = 1, isVariable = false, timer = 10000, frequency = 25) {
            const $this = this;
            let elements = isVariable ? window[waitFor] : document.querySelectorAll(waitFor);
            if (timer <= 0) return;
            (!isVariable && elements.length >= minElements) ||
                (isVariable && typeof window[waitFor] !== 'undefined') ? callback(elements) : setTimeout(
                    () => $this.waitForElem(waitFor, callback, minElements, isVariable, timer - frequency), frequency
                );
        },

        insertAfter: function (el, html) {
            if (!el || !html) return;
            el.insertAdjacentHTML("afterend", html);
        },

        insertBefore: function (el, html) {
            if (!el || !html) return;
            el.insertAdjacentHTML("beforebegin", html);
        },

        buildItemsList: function (data = [], html) {
            if (!Array.isArray(data) || typeof html !== "function") return "";
            return data.map((item) => html(item)).join("");
        },

        isMobileScreen: function () {
            return window.innerWidth <= 768;
        },
        debounce: function (func, wait) {
            let timeout;
            let called = false;

            return function (...args) {
                const context = this;

                if (!called) {
                    func.apply(context, args);
                    called = true;
                }

                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    called = false;
                }, wait);
            };
        },
        observeMutations: function (target, callback, options = {}) {
            const {
                config = { childList: true, subtree: true, attributes: false, characterData: false },
                once = false,
            } = options;

            if (!target || typeof callback !== 'function') {
                console.error('observeMutations: Invalid target or callback');
                return;
            }

            const observer = new MutationObserver((mutations, obs) => {
                callback(mutations, obs);
                if (once) obs.disconnect();
            });

            console.log(config);

            observer.observe(target, config);
            return observer;
        },
        scrollToElement: function (element, offset = 0) {
            if (!element) return;

            const y = element.getBoundingClientRect().top + window.pageYOffset + offset;

            window.scrollTo({
                top: y,
                behavior: 'smooth'
            });
        },
        injectSwiper: function () {
            var swiperCssLink = document.createElement('link');
            swiperCssLink.rel = 'stylesheet';
            swiperCssLink.type = 'text/css';
            swiperCssLink.href = 'https://unpkg.com/swiper/swiper-bundle.min.css';
            document.head.appendChild(swiperCssLink);

            var swiperJs = document.createElement("script");
            swiperJs.type = "text/javascript";
            swiperJs.src = "https://unpkg.com/swiper/swiper-bundle.min.js";
            document.head.appendChild(swiperJs);
        },
         toTruncatedFixed: function(num, decimals = 2) {
            // Usage examples:

            // console.log(toTruncatedFixed(23.7898));        // "23.78"
            // console.log(toTruncatedFixed(23.7));           // "23.70"
            // console.log(toTruncatedFixed(5.6789, 3));      // "5.678"
            // console.log(toTruncatedFixed(-1.2345, 1));     // "-1.2"
            // console.log(toTruncatedFixed(0.9999, 2));      // "0.99"
            // console.log(toTruncatedFixed(123));            // "123.00"
            let factor = Math.pow(10, decimals);
            let truncated = Math.trunc(num * factor) / factor;
            return truncated.toFixed(decimals);
        }
    };

    const SB095DM = {
        init: function () {
            this.mainCSS();
            this.mainJS();
        },
        mainCSS: function () {
            const s = document.createElement("style");
            s.setAttribute("type", "text/css");
            document.head.appendChild(s).textContent = `
            .linkArea {
                color: #1B73B3;
                font-family: 'neue-haas-unica';
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: 100%;
                border-bottom: 1px solid #1B73B3;
                display: inline-block;
                padding-bottom: 4px;
                margin-bottom: 20px;
                cursor: pointer;
                margin-top: 5px;
            }

            .linkArea svg {
                margin-left: 10px;
                position: relative;
                top: 4px;
                transform: translateX(0);
                transition: all .3s ease-in-out;
            }

            .linkArea:hover svg {
                transform: translateX(4px);
            }

            .product__info-wrapper .product__text.subtitle {
                margin-bottom: 2px;
            }

            @media (max-width: 370px) {
              
            }

            `;
        },
        mainJS: function () {
            document.body.classList.add(TEST_CONFIG.id);
            // Add any other DOM logic here
            const icon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <g clip-path="url(#clip0_15_93)">
                    <path d="M6.11959e-07 9.5L16 9.5M16 9.5L11.75 13.5M16 9.5L11.75 5.5" stroke="#1B73B3" stroke-width="1.28571" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                    <clipPath id="clip0_15_93">
                    <rect width="18" height="18" fill="white" transform="translate(18) rotate(90)"/>
                    </clipPath>
                </defs>
                </svg>`;
            function scrollToElementWithOffset(selector, offset = 0) {
                const element = document.querySelector(selector);
                if (element) {
                    const elementTop = element.getBoundingClientRect().top + window.scrollY;
                    const scrollPosition = elementTop - offset;
            
                    window.scrollTo({
                        top: scrollPosition,
                        behavior: 'smooth', // Enables smooth scrolling
                    });
                }
            }
            const linkArea = `<div class="linkArea">View Third-Party Testing${icon}</div>`;
            helpers.insertAfter(document.querySelector('.product__info-wrapper .product__text.subtitle'), linkArea);

            document.querySelector('.linkArea').addEventListener('click', () => {
                scrollToElementWithOffset('.sb-product-testing__container', 100);
            });

        },
    };

    // Initialize when the element is available
    helpers.waitForElem(TEST_CONFIG.selector, (elements) => {
        // console.log("Elements found:", elements);
        if (document.querySelector(TEST_CONFIG.variationClass)) return;

        console.log(`${TEST_CONFIG.id} - ${TEST_CONFIG.name} - Variation ${TEST_CONFIG.variation}`);
        SB095DM.init();
    });
})();